export default __webpack_public_path__ + "static/media/met-before-after-submitted-bg.17c38ff3.png";